export default () => ({
  // All Saved Data with default naics key
  //  all naics selected after the save button
  allSaved: { "naics": []},
  // all naics checked from tree
  allChecked: { "naics": []},
  // Determines if search has results
  searchHasResults: false,
  // Determines if a selection has been made
  hasNoSelection: true,
  // Is an array as Naics asn a key and their examples from Algolia Hit
  hasExamplesByNaics: {},
  // New Tree Structure derivied from InitTree and Algolia Hits 
  reducedTree:[],
  // Final tree Structure when user clicked on Save 
  savedTree: [],
  // Search Keyword
  keywordSaved: "",
  // Initial Tree Structure from naics-2017-*.js
  initTree:[],
  // Level of Naics that user chan check on Tree
  levelSelectable:[],
  // because some top level of Naics can be 30-33, this map to 30=33, 31=33 etc..
  mapTopLevelNaics:[],
  // Alogia Return from user search
  algoliaHitsResult: [],
  // All Industries definition from Directus
  allIndustriesDirecturs: {},
  // To indicate if should display Industry definition in Detail Pane
  showDetail: false,
  // Node Info on selection
  nodeInfo: []
});
